import { FC, useState } from "react";
import { MultiSelect } from "./MultiSelect";
import { t } from "i18next";

export type FiltersCalendarprops = {
  filtersOpen: () => void;
  options: Array<any>;
  selectedGroups: any;
  setSelectedGroups: () => void;
};

export const FiltersCalendar: FC<FiltersCalendarprops> = ({
  filtersOpen,
  options,
  selectedGroups,
  setSelectedGroups,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay de fondo */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50"
        onClick={filtersOpen}
      />

      {/* Modal */}
      <div className="relative bg-white w-full max-w-md rounded-lg shadow-xl">
        {/* Header del modal */}
        <div className="flex justify-end p-6 border-b border-gray-200">
          <button
            type="button"
            className="text-gray-400 hover:text-gray-600 text-2xl font-light"
            onClick={filtersOpen}
          >
            <span className="sr-only">{t("general.close")}</span>
            &times;
          </button>
        </div>

        {/* Contenido del formulario */}
        <div className="p-6">
          <form action="#" method="GET" className="space-y-4">
            <div className="w-full">
              <MultiSelect
                selectedOptions={selectedGroups}
                setSelectedOptions={setSelectedGroups}
                title={t("lesson.views.groups")}
                options={options}
              />
            </div>
          </form>
        </div>

        {/* Botones de acción */}
        <div className="flex justify-end gap-3 p-6 border-t border-gray-200">
          <button
            type="button"
            onClick={filtersOpen}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {t("general.cancel")}
          </button>
          <button
            type="button"
            onClick={filtersOpen}
            className="px-4 py-2 text-sm font-medium text-white bg-primary border border-transparent rounded-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {t("general.save")}
          </button>
        </div>
      </div>
    </div>
  );
};
